import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
import vailcode from "@utils/errcode";
export default {
  name: "ranks",
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo", "settingInfo"])
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          this.setWowAnim();
          this.initFn();
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    const tabList = [{
      label: "Task",
      value: 0
    }, {
      label: "Friends",
      value: 1
    }];
    return {
      tabList,
      selectTab: {
        label: "Task",
        value: 0
      },
      ranklist: null,
      activityInfoList: null,
      activityInfo: null,
      activityRewards: null,
      activityRaning: null,
      activityRaningUser: null,
      activityIndex: 0,
      selectActivityTime: 0,
      isPage: true
    };
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {
    ...userVuex.mapMutations(["setUserInfo"]),
    async onTab(item) {
      this.selectTab = item;
      this.initFn();
    },
    async initFn() {
      this.isPage = true;
      this.activityInfoList = await this.getActivityList();
      this.activityIndex = this.setActivityIndex(this.activityInfoList);
      this.scrollToCenter(this.activityIndex);
      this.setActivityData(this.activityIndex, false);
    },
    async setActivityData(index, isPage = true) {
      try {
        isPage && (this.isPage = true);
        this.selectActivityTime = index;
        const items = this.activityInfoList[index];
        this.activityInfo = items;
        this.setActivityInfo(this.activityInfo);
        this.activityRewards = await this.getActivityItems(this.activityInfo.id);
        const rankInfo = await this.getActivityRanking(this.activityInfo.id);
        if (rankInfo) {
          this.activityRaning = rankInfo.ranking;
          this.activityRaningUser = rankInfo.user;
        }
        this.isPage = false;
      } catch (err) {
        this.isPage = false;
      }
    },
    setActivityIndex(res) {
      // 当前本地时间（自动带本地时区）
      const now = new Date();
      const utcOffset = now.getTimezoneOffset(); // 与UTC的分钟差
      const utcDate = new Date(now.getTime() + utcOffset * 60000).getTime();
      let activeIndex = 0;
      res.forEach((item, index) => {
        const startUTC = new Date(item.start_time).getTime();
        const endUTC = new Date(item.end_time).getTime();
        if (utcDate >= startUTC && utcDate <= endUTC) {
          activeIndex = index;
        }
      });
      return activeIndex;
    },
    setActivityInfo(data) {
      this.activityInfo = data;
    },
    async getActivityList() {
      return new Promise(async resolve => {
        const res = await this.$http.post("/rank/activity/list", {
          type: this.selectTab.value
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          resolve(data);
        }, () => resolve());
      });
    },
    async getActivityItems(activity_id) {
      return new Promise(async resolve => {
        const res = await this.$http.post("/rank/activity/items", {
          activity_id
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          resolve(data);
        }, () => resolve());
      });
    },
    async getActivityRanking(activity_id) {
      return new Promise(async resolve => {
        const res = await this.$http.post("/rank/activity/ranking", {
          activity_id
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          resolve({
            ranking: data.list,
            user: data.self
          });
        }, () => resolve());
      });
    },
    async onSelectActivityTime(item, index) {
      if (this.selectActivityTime == index) return;
      this.selectActivityTime = index;
      this.scrollToCenter(index);
      await this.setActivityData(index);
    },
    scrollToCenter(index) {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        const items = container.querySelectorAll(".ranks-more-times-item");
        const item = items[index];
        if (!container || !item) return;
        const containerWidth = container.clientWidth;
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const scrollLeft = itemCenter - containerWidth / 2;

        // 如果内容超出父级 -> 正常滚动
        console.log("container.scrollWidth=====", container.scrollWidth, containerWidth);
        if (container.scrollWidth > containerWidth) {
          container.scrollTo({
            left: scrollLeft,
            behavior: "smooth"
          });
        } else {
          // 不足撑满 -> 通过 transform 居中
          const totalWidth = Array.from(items).reduce((sum, el) => sum + el.offsetWidth, 0);
          const itemOffset = item.offsetLeft + item.offsetWidth / 2;
          const offset = containerWidth / 2 - itemOffset;
          container.style.transition = "transform 0.3s";
          container.style.transform = `translateX(${offset}px)`;
        }
      });
    },
    onShare(type) {
      const ref_code = this.userInfo.ref_code;
      const linkname = "Invite more friends now to eam free gift shards on each leaderboard\n";
      let url = `https://t.me/share/url?text=${encodeURIComponent(linkname)}&url=https://t.me/${this.settingInfo.botname}/app?startapp=ref_${ref_code}`;
      this.WebApp.openTelegramLink(url);
    }
  },
  async mounted() {}
};